/*
 * Year -> Make -> Model picker (sections/vehicle-picker.liquid).
 *
 * Data: {"y": {"2005": {"Toyota": [["Camry", "camry"], ...]}}}
 * Search goes to /collections/all/<model-handle>+<year>, Shopify's tag filter.
 *
 * The vehicle on a results page is read from the URL's tags, never from
 * memory, so the page can only ever name the vehicle it is filtered by. The
 * last vehicle is remembered in this browser and offered as a link elsewhere.
 */
(function () {
  var STORE_KEY = 'volcano-vehicle';
  // Spanish pages live under /es/: stay there, and speak Spanish.
  var IS_ES = (document.documentElement.lang || '').slice(0, 2) === 'es';
  var ALL = (IS_ES ? '/es' : '') + '/collections/all';
  var ES = {
    'Select': 'Seleccionar', 'Select year': 'Seleccione el año', 'Select make': 'Seleccione la marca',
    'Select model': 'Seleccione el modelo', 'Most popular': 'Más populares', 'All makes': 'Todas las marcas',
    'All models': 'Todos los modelos', 'Close': 'Cerrar', 'Part type': 'Tipo de pieza', 'Make': 'Marca',
    'part fits your': 'pieza para su', 'parts fit your': 'piezas para su',
    'No parts match these filters. Call': 'Ninguna pieza coincide con estos filtros. Llame al',
    'Parts could not load. Please refresh, or call': 'No se pudieron cargar las piezas. Actualice la página o llame al',
    'Photo coming soon': 'Foto próximamente', 'CAPA certified': 'Certificado CAPA', 'Standard': 'Estándar',
    'Left / driver': 'Izquierdo / conductor', 'Right / passenger': 'Derecho / pasajero',
    'Not side specific': 'Sin lado específico', 'Illustration': 'Ilustración', 'Drawing of a': 'Dibujo de',
    '(illustration, not a photo of the item)': '(ilustración, no es foto de la pieza)',
    'Bumper & Cover': 'Parachoques y cubierta', 'Mirror': 'Espejo', 'Head Lamp': 'Faro delantero',
    'Fender': 'Guardabarro', 'Bracket & Retainer': 'Soporte y retenedor', 'Tail Lamp': 'Luz trasera',
    'Other Lamp': 'Otra luz', 'Grille': 'Parrilla', 'Hood & Hinge': 'Capó y bisagra', 'Fog Lamp': 'Faro antiniebla',
    'Radiator, Condenser & Fan': 'Radiador, condensador y ventilador', 'Filler & Panel': 'Relleno y panel',
    'Bumper Reinforcement': 'Refuerzo de parachoques', 'Door': 'Puerta', 'Radiator Support': 'Soporte de radiador',
    'Other': 'Otro'
  };
  function L(t) { return IS_ES && ES[t] ? ES[t] : t; }
  var dataPromise = null;

  function loadData(url) {
    if (!dataPromise) {
      dataPromise = fetch(url, { credentials: 'omit' }).then(function (r) {
        if (!r.ok) throw new Error('vehicle data ' + r.status);
        return r.json();
      });
    }
    return dataPromise;
  }

  function handleize(t) {
    return String(t).trim().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  }

  function readSaved() {
    try {
      var v = JSON.parse(localStorage.getItem(STORE_KEY) || 'null');
      return v && v.year && v.make && v.model ? v : null;
    } catch (e) {
      return null;
    }
  }
  function save(v) {
    try { localStorage.setItem(STORE_KEY, JSON.stringify(v)); } catch (e) { /* private mode */ }
  }
  function forget() {
    try { localStorage.removeItem(STORE_KEY); } catch (e) { /* private mode */ }
  }

  function urlFor(v) {
    return ALL + '/' + encodeURIComponent(v.model) + '+' + encodeURIComponent(v.year);
  }

  // popular: values to repeat at the top under "Most popular" (best sellers
  // first, from scripts/website_build_popularity.py), before the full A-Z list.
  function fill(select, placeholder, values, popular, allLabel) {
    select.innerHTML = '';
    var first = document.createElement('option');
    first.value = '';
    first.textContent = placeholder;
    select.appendChild(first);
    function add(parent, v) {
      var o = document.createElement('option');
      o.value = v[0];
      o.textContent = v[1];
      parent.appendChild(o);
    }
    var top = (popular || []).map(function (val) {
      return values.filter(function (v) { return v[0] === val; })[0];
    }).filter(Boolean);
    if (top.length && values.length > top.length + 2) {
      var g1 = document.createElement('optgroup');
      g1.label = L('Most popular');
      top.forEach(function (v) { add(g1, v); });
      var g2 = document.createElement('optgroup');
      g2.label = allLabel || 'All';
      values.forEach(function (v) { add(g2, v); });
      select.appendChild(g1);
      select.appendChild(g2);
    } else {
      values.forEach(function (v) { add(select, v); });
    }
    select.disabled = values.length === 0;
  }

  // A few products still carry old plural type names; fold them into the
  // current ones so a filter never shows "Bumper" and "Bumpers" side by side.
  // Bumpers and their light covers / bezels share one type: "Bumper & Cover".
  var TYPE_ALIASES = {
    'Bumpers': 'Bumper & Cover', 'Bumper': 'Bumper & Cover', 'Mirrors': 'Mirror', 'Fenders': 'Fender', 'Hood': 'Hood & Hinge',
    'Hoods & Hinges': 'Hood & Hinge', 'Lamps': 'Other Lamp', 'Tail Lights & Covers': 'Tail Lamp',
    'Radiators, Condensers & Fans': 'Radiator, Condenser & Fan', 'Headlights': 'Headlight',
    'Grills': 'Grille', 'Fog Lights & Covers': 'Fog Lamp', '': 'Other'
  };
  // What a type is called on screen ("lamps", not "lights"); filters still use the type itself.
  var TYPE_LABELS = { 'Headlight': 'Head Lamp' };
  // Results order: the big parts people call about first, small brackets and
  // trim last (alphabetical put $20 brackets at the top).
  var TYPE_ORDER = ['Bumper & Cover', 'Headlight', 'Hood & Hinge', 'Fender', 'Grille', 'Mirror', 'Tail Lamp', 'Fog Lamp',
    'Door', 'Radiator Support', 'Bumper Reinforcement', 'Radiator, Condenser & Fan', 'Other Lamp', 'Filler & Panel',
    'Bracket & Retainer', 'Other'];
  function typeRank(t) { var i = TYPE_ORDER.indexOf(t); return i === -1 ? TYPE_ORDER.length - 1 : i; }
  function typeLabel(t) { return L(TYPE_LABELS[t] || t); }
  var SIDES = { Left: 'Left / driver', Right: 'Right / passenger', '': 'Not side specific' };

  function esc(t) {
    return String(t == null ? '' : t).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  // Results grid with Part type / Side / CAPA filters, all in the browser:
  // the vehicle's products come from collection.vp-json in one request.
  function showResults(root, vehicle, name) {
    var grid = root.querySelector('[data-vp-grid]');
    var count = root.querySelector('[data-vp-count]');
    var aside = root.querySelector('[data-vp-filters]');
    var details = root.querySelector('[data-vp-filter-details]');
    var chosen = { type: {}, side: {}, capa: {} };
    // no photo: the part type's line drawing (snippets/part-drawing.liquid)
    var drawings = {};
    try { drawings = JSON.parse(root.getAttribute('data-part-drawings') || '{}'); } catch (e) { /* keep the text placeholder */ }
    // trim pieces filed under bigger types get the cover / molding drawing
    // (same rules as snippets/part-drawing.liquid)
    var COVER_TYPES = ['Bumper & Cover', 'Fog Lamp', 'Bracket & Retainer', 'Filler & Panel', 'Other'];
    var MOLDING_TYPES = ['Bracket & Retainer', 'Other'];
    function drawingFor(p) {
      var t = String(p.t || '').toLowerCase();
      if (MOLDING_TYPES.indexOf(p.type) !== -1 && /molding|moulding|mldg|garnish| trim/.test(t)) return drawings._molding;
      if (COVER_TYPES.indexOf(p.type) !== -1 && /light cover|lamp cover|fog cover|frontl\. cover|bezel/.test(t)) return drawings._cover;
      return drawings[p.type];
    }
    var items = [];

    function facetValue(p, key) {
      if (key === 'type') return p.type;
      if (key === 'side') return SIDES[p.sd || ''];
      return p.c ? 'CAPA certified' : 'Standard';
    }
    function passes(p, skip) {
      return ['type', 'side', 'capa'].every(function (k) {
        if (k === skip) return true;
        var on = Object.keys(chosen[k]).filter(function (v) { return chosen[k][v]; });
        return !on.length || on.indexOf(facetValue(p, k)) !== -1;
      });
    }
    function drawFacets() {
      ['type', 'side', 'capa'].forEach(function (k) {
        var counts = {};
        items.filter(function (p) { return passes(p, k); }).forEach(function (p) {
          var v = facetValue(p, k);
          counts[v] = (counts[v] || 0) + 1;
        });
        var all = {};
        items.forEach(function (p) { all[facetValue(p, k)] = true; });
        var values = Object.keys(all).sort();
        root.querySelector('[data-vp-facet-wrap="' + k + '"]').hidden = values.length < 2;
        root.querySelector('[data-vp-facet="' + k + '"]').innerHTML = values.map(function (v) {
          return '<label class="vp__opt"><input type="checkbox" data-k="' + k + '" value="' + esc(v) + '"' +
            (chosen[k][v] ? ' checked' : '') + '> ' + esc(k === 'type' ? typeLabel(v) : L(v)) + '<span class="ct">' + (counts[v] || 0) + '</span></label>';
        }).join('');
      });
    }
    function drawCount() {
      var badge = root.querySelector('[data-vp-filter-count]');
      if (!badge) return;
      var n = 0;
      ['type', 'side', 'capa'].forEach(function (k) {
        n += Object.keys(chosen[k]).filter(function (v) { return chosen[k][v]; }).length;
      });
      badge.textContent = n;
      badge.hidden = n === 0;
    }
    function drawGrid() {
      drawCount();
      var shown = items.filter(function (p) { return passes(p); });
      count.textContent = shown.length + ' ' + L(shown.length === 1 ? 'part fits your' : 'parts fit your') + ' ' + name;
      grid.innerHTML = shown.length ? shown.map(function (p) {
        return '<a class="vp__card" href="' + esc(p.u) + '">' +
          (p.i ? '<img src="' + esc(p.i) + '" alt="' + esc(p.t) + '" loading="lazy" width="400" height="400">'
               : drawingFor(p) ? '<span class="vp__illus-wrap"><img class="vp__drawing" src="' + esc(drawingFor(p)) + '" alt="' + L('Drawing of a') + ' ' +
                   esc(typeLabel(p.type)) + ' ' + L('(illustration, not a photo of the item)') + '" loading="lazy" width="400" height="400">' +
                   '<span class="vp__illus">' + L('Illustration') + '</span></span>'
               : '<span class="vp__noimg">' + L('Photo coming soon') + '</span>') +
          '<div class="vp__card-body"><span class="vp__name">' + esc(p.t) + '</span>' +
          (p.s ? '<span class="vp__sku">' + esc(p.s) + '</span>' : '') +
          (p.c ? '<span class="vp__capa">' + L('CAPA certified') + '</span>' : '') +
          '<span class="vp__price">' + esc(p.p) + '</span></div></a>';
      }).join('') : '<p class="vp__empty">' + L('No parts match these filters. Call') + ' <a href="tel:+17185055585">(718) 505-5585</a>.</p>';
    }

    aside.addEventListener('change', function (e) {
      var t = e.target;
      if (!t.dataset || !t.dataset.k) return;
      chosen[t.dataset.k][t.value] = t.checked;
      drawFacets();
      drawGrid();
    });

    // collection.vp-json pages by 250; a busy vehicle can have more than that.
    function fetchAll(page, acc) {
      return fetch(root.getAttribute('data-results-url') + '&page=' + page, { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          acc = acc.concat(data.products || []);
          return (data.products || []).length === 250 && page < 8 ? fetchAll(page + 1, acc) : acc;
        });
    }

    fetchAll(1, [])
      .then(function (all) {
        items = all.map(function (p) {
          p.type = TYPE_ALIASES.hasOwnProperty(p.ty) ? TYPE_ALIASES[p.ty] : p.ty;
          return p;
        }).sort(function (a, b) { return typeRank(a.type) - typeRank(b.type) || a.type.localeCompare(b.type) || a.t.localeCompare(b.t); });
        if (details) details.open = window.innerWidth >= 990;
        // "Shop by part" with a remembered vehicle lands here as #type=Bumper
        var want = decodeURIComponent((location.hash.match(/type=([^&]+)/) || [])[1] || '');
        if (want && TYPE_ALIASES.hasOwnProperty(want)) want = TYPE_ALIASES[want];
        if (want && items.some(function (p) { return p.type === want; })) chosen.type[want] = true;
        aside.hidden = false;
        drawFacets();
        drawGrid();
      })
      .catch(function () {
        grid.innerHTML = '<p class="vp__empty">' + L('Parts could not load. Please refresh, or call') + ' <a href="tel:+17185055585">(718) 505-5585</a>.</p>';
      });
  }


  // Our own dropdown list in place of the browser's plain one. The real
  // <select> stays in the form (hidden) and keeps the value; this only draws
  // it: a popover on desktop, a sheet from the bottom on phones.
  var openDD = null;
  function closeDD() {
    if (!openDD) return;
    openDD.panel.hidden = true;
    openDD.btn.setAttribute('aria-expanded', 'false');
    document.documentElement.classList.remove('vp-dd-lock');
    openDD = null;
  }
  document.addEventListener('click', function (e) {
    if (openDD && !openDD.wrap.contains(e.target) && !openDD.panel.contains(e.target)) closeDD();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && openDD) { var b = openDD.btn; closeDD(); b.focus(); }
  });

  function enhance(sel, title, onPick) {
    var wrap = document.createElement('div');
    wrap.className = 'vp-dd';
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'vp-dd__btn';
    btn.setAttribute('aria-haspopup', 'listbox');
    btn.setAttribute('aria-expanded', 'false');
    var panel = document.createElement('div');
    panel.className = 'vp-dd__panel' + (sel.hasAttribute('data-vp-year') ? ' vp-dd__panel--grid' : '');
    panel.hidden = true;
    panel.innerHTML = '<div class="vp-dd__head"><span>' + esc(title) + '</span>' +
      '<button type="button" class="vp-dd__close" aria-label="' + L('Close') + '">&times;</button></div>' +
      '<div class="vp-dd__list" role="listbox"></div>';
    sel.parentNode.insertBefore(wrap, sel);
    wrap.appendChild(sel);
    wrap.appendChild(btn);
    wrap.appendChild(panel);
    sel.classList.add('vp-dd__native');
    sel.tabIndex = -1;
    var list = panel.querySelector('.vp-dd__list');

    function open() {
      if (sel.disabled) return;
      closeDD();
      function opt(o) {
        return '<button type="button" role="option" class="vp-dd__opt' + (o.value === sel.value ? ' is-on' : '') +
          '" data-v="' + esc(o.value) + '">' + esc(o.textContent) + '</button>';
      }
      list.innerHTML = Array.prototype.map.call(sel.children, function (n) {
        if (n.tagName === 'OPTGROUP') {
          return '<div class="vp-dd__group">' + esc(n.label) + '</div>' + Array.prototype.map.call(n.children, opt).join('');
        }
        return n.value ? opt(n) : '';
      }).join('');
      var phone = window.innerWidth < 750;
      // Phones: the sheet hangs off <body>, so nothing on the page can clip,
      // cover or shift it. Desktop: the popover sits under its box.
      var home = phone ? document.body : wrap;
      if (panel.parentNode !== home) home.appendChild(panel);
      panel.hidden = false;
      btn.setAttribute('aria-expanded', 'true');
      if (phone) document.documentElement.classList.add('vp-dd-lock');
      openDD = { wrap: wrap, btn: btn, panel: panel };
      // show the chosen value without scrolling the page itself
      var on = list.querySelector('.is-on');
      list.scrollTop = on ? on.offsetTop - list.clientHeight / 2 + on.offsetHeight / 2 : 0;
      if (!phone) {
        (on || list.querySelector('.vp-dd__opt') || btn).focus({ preventScroll: true });
        // a long list opened low on the screen: bring all of it into view
        // (a moment later: a smooth scroll started together with focus() is cancelled)
        var over = panel.getBoundingClientRect().bottom - window.innerHeight + 16;
        if (over > 0) setTimeout(function () { window.scrollBy({ top: over, behavior: 'smooth' }); }, 30);
      }
    }
    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      if (openDD && openDD.wrap === wrap) closeDD(); else open();
    });
    panel.querySelector('.vp-dd__close').addEventListener('click', function (e) { e.stopPropagation(); closeDD(); btn.focus(); });
    panel.addEventListener('click', function (e) {
      if (e.target === panel) { closeDD(); return; }   // the dimmed area around the phone sheet
      var o = e.target.closest('.vp-dd__opt');
      if (!o) return;
      e.stopPropagation();
      sel.value = o.getAttribute('data-v');
      closeDD();
      sel.dispatchEvent(new Event('change'));
      if (onPick) onPick();
    });
    sel._dd = { btn: btn, open: open };
  }
  function syncDD(sel) {
    if (!sel._dd) return;
    var b = sel._dd.btn;
    b.textContent = sel.selectedIndex > 0 ? sel.options[sel.selectedIndex].textContent : L('Select');
    b.disabled = sel.disabled;
    b.classList.toggle('vp-set', sel.classList.contains('vp-set'));
    b.classList.toggle('vp-next', sel.classList.contains('vp-next'));
  }

  function init(root) {
    var q = function (s) { return root.querySelector(s); };
    var year = q('[data-vp-year]');
    var make = q('[data-vp-make]');
    var model = q('[data-vp-model]');
    var submit = q('[data-vp-submit]');
    var form = q('[data-vp-form]');
    var panel = q('[data-vp-panel]');
    var error = q('[data-vp-error]');
    var savedBox = q('[data-vp-saved]');
    var bar = q('[data-vp-current]');
    var tags = (root.getAttribute('data-current-tags') || '').split(',').map(handleize);

    loadData(root.getAttribute('data-data-url')).then(function (data) {
      var years = data.y || {};
      var pop = data.pop || { makes: [], models: {} };

      function refresh() {
        submit.disabled = !(year.value && make.value && model.value);
        // filled boxes turn blue; the next box to fill is highlighted
        var next = null;
        [year, make, model].forEach(function (sel) {
          sel.classList.toggle('vp-set', !!sel.value);
          if (!next && !sel.value && !sel.disabled) next = sel;
        });
        [year, make, model].forEach(function (sel) { sel.classList.toggle('vp-next', sel === next); syncDD(sel); });
      }
      function select(v) {
        year.value = v.year;
        year.dispatchEvent(new Event('change'));
        make.value = v.make;
        make.dispatchEvent(new Event('change'));
        model.value = v.model;
        refresh();
      }
      // The vehicle a results URL is filtered by, looked up in the data.
      function vehicleFromTags() {
        for (var i = 0; i < tags.length; i++) {
          var y = tags[i];
          if (!years[y]) continue;
          for (var mk in years[y]) {
            var hit = years[y][mk].filter(function (m) { return tags.indexOf(m[1]) !== -1; })[0];
            if (hit) return { year: y, make: mk, model: hit[1], label: hit[0] };
          }
        }
        return null;
      }
      function nameOf(v) { return v.year + ' ' + v.make + ' ' + v.label; }

      // Homepage tiles open /collections/all?type=Bumper or ?make=Toyota: the
      // part type is kept for the search, the make narrows the years and is
      // picked for the customer.
      var params = new URLSearchParams(location.search);
      var ctxType = params.get('type') || '';
      if (ctxType && TYPE_ALIASES.hasOwnProperty(ctxType)) ctxType = TYPE_ALIASES[ctxType];
      var ctxMake = params.get('make') || '';
      var hash = ctxType ? '#type=' + encodeURIComponent(ctxType) : '';
      var ctxBox = q('[data-vp-context]');
      if (ctxBox && (ctxType || ctxMake)) {
        q('[data-vp-context-kind]').textContent = L(ctxType ? 'Part type' : 'Make');
        q('[data-vp-context-name]').textContent = ctxType ? typeLabel(ctxType) : ctxMake;
        ctxBox.hidden = false;
      }

      var yearList = Object.keys(years).filter(function (y) { return !ctxMake || years[y][ctxMake]; });
      fill(year, L('Select'), yearList.sort().reverse().map(function (y) { return [y, y]; }));
      enhance(year, L('Select year'), function () { if (!make.disabled && !make.value) make._dd.open(); });
      enhance(make, L('Select make'), function () { if (!model.disabled) model._dd.open(); });
      enhance(model, L('Select model'));
      refresh();
      year.addEventListener('change', function () {
        fill(make, L('Select'), Object.keys(years[year.value] || {}).sort().map(function (m) { return [m, m]; }),
          pop.makes.slice(0, 6), L('All makes'));
        fill(model, L('Select'), []);
        if (ctxMake && years[year.value] && years[year.value][ctxMake]) {
          make.value = ctxMake;
          make.dispatchEvent(new Event('change'));
          if (!model.disabled) setTimeout(function () { model._dd.open(); }, 0);
        }
        refresh();
      });
      make.addEventListener('change', function () {
        var list = (years[year.value] || {})[make.value] || [];
        fill(model, L('Select'), list.map(function (m) { return [m[1], m[0]]; }),
          (pop.models[make.value] || []).filter(function (h) {
            return list.some(function (m) { return m[1] === h; });
          }).slice(0, 4), L('All models'));
        refresh();
      });
      model.addEventListener('change', refresh);

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (!(year.value && make.value && model.value)) return;
        var v = { year: year.value, make: make.value, model: model.value, label: model.options[model.selectedIndex].textContent };
        save(v);
        window.location.href = urlFor(v) + hash;
      });

      var current = root.getAttribute('data-mode') === 'results' ? vehicleFromTags() : null;
      if (current) {
        save(current);
        select(current);
        q('[data-vp-current-name]').textContent = nameOf(current);
        bar.hidden = false;
        showResults(root, current, nameOf(current));
        q('[data-vp-change]').addEventListener('click', function () {
          panel.hidden = !panel.hidden;
          if (!panel.hidden) year._dd.btn.focus();
        });
        q('[data-vp-clear]').addEventListener('click', function () {
          forget();
          window.location.href = ALL;
        });
      } else {
        if (panel) panel.hidden = false;
        var saved = readSaved();
        if (saved && years[saved.year] && years[saved.year][saved.make]) {
          q('[data-vp-saved-name]').textContent = nameOf(saved);
          q('[data-vp-saved-link]').href = urlFor(saved) + hash;
          savedBox.hidden = false;
          q('[data-vp-forget]').addEventListener('click', function () {
            forget();
            savedBox.hidden = true;
          });
        }
      }
    }).catch(function () {
      if (panel) panel.hidden = false;
      error.hidden = false;
    });
  }

  function start() {
    document.querySelectorAll('[data-vehicle-picker]').forEach(init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
